<template>
  <div>
    <!-- banner -->
<!--    <div class="banner" :style="cover">-->
<!--      <h1 class="banner-title">关于我</h1>-->
<!--    </div>-->
    <!-- 关于我内容 -->

    <div v-show="!isvaildcheck" class="centerContainer">
      <button class="imgButton" @click="checkIsAdmin">
          <svg width="96" height="96" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="showLock">
            <rect x="6" y="22" width="36" height="22" rx="2" fill="none" stroke="#333" stroke-width="4" stroke-linejoin="round"/>
            <path d="M14 22V14C14 8.47715 18.4772 4 24 4C29.5228 4 34 8.47715 34 14V22" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M24 30V36" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg width="96" height="96" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="!showLock">
            <rect x="7" y="22.0476" width="34" height="22" rx="2" fill="none" stroke="#333" stroke-width="4" stroke-linejoin="round"/>
            <path d="M14 22V14.0047C13.9948 8.87022 17.9227 4.56718 23.0859 4.05117C28.249 3.53516 32.9673 6.97408 34 12.0059" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M24 30V36" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <el-dialog title="身份校验" :visible.sync="isAdminDialog" width="30%">
              <el-form ref="paperform" :inline="true" :model="admincheck" label-width="80px">
                <el-row>
                  <el-col :span="24">
                  <el-form-item label="密码" prop="pass">
                      <el-input v-model="admincheck.password"></el-input>
                  </el-form-item>
                  </el-col>
                </el-row>
              </el-form>

              <div slot="footer" class="dialog-footer">
                  <el-button @click="isAdminDialog = false; showLock = true;">取 消</el-button>
                  <el-button type="primary" @click="vaildIsAmind">确 认</el-button>
              </div>

      </el-dialog>
    </div>

    <div v-show="isvaildcheck">
      <div style="width:100%;height:100%" >
      <iframe id="chat" src="https://chat.letmecode.cn"
              style="width:100%;height:975px;border:0px;"
              scrolling="no"
              frameborder="0"
      ></iframe>
    </div>
    </div>
<!--    <v-card class="blog-container">-->
<!--      &lt;!&ndash; 博主头像 &ndash;&gt;-->
<!--      <div class="my-wrapper">-->
<!--        <v-avatar size="110">-->
<!--          <img class="author-avatar" :src="avatar" />-->
<!--        </v-avatar>-->
<!--      </div>-->
<!--      &lt;!&ndash; 介绍 &ndash;&gt;-->
<!--      <div-->
<!--        ref="about"-->
<!--        class="about-content markdown-body"-->
<!--        v-html="aboutContent"-->
<!--      />-->
<!--    </v-card>-->
  </div>
</template>

<script>
import Clipboard from "clipboard";
import {rightCheck} from "../../api";

export default {
  created() {
    // this.getAboutContent();
    this.admincheck.password = sessionStorage.getItem("chatPossword");
    if (this.admincheck.password != null) {
      console.log(this.admincheck.password);
      this.vaildIsAmind();
    }
  },
  destroyed() {
    // this.clipboard.destroy();
  },
  metaInfo:{
    meta: [{
      name: 'keyWords',
      content: "个人笔记的分享,开源博客,www.letmecode.cn"  //变量或字符串
    }, {
      name: 'description',
      content: "一个专注于技术分享的博客平台,大家以共同学习,乐于分享,拥抱开源的价值观进行学习交流"
    }]
  },
  data: function() {
    return {
      aboutContent: "",
      img: process.env.VUE_APP_IMG_API,
      clipboard: null,
      imgList: [],
      isAdminDialog: false,
      isvaildcheck: false,
      showLock: true,
      admincheck: {
        password: "",
      },
    };
  },
  methods: {
    getAboutContent() {
      const that = this;
      var aboutMe = this.$store.state.blogInfo.webSite.aboutMe;
        this.markdownToHtml(aboutMe);
        this.$nextTick(() => {
          // 添加代码复制功能
          this.clipboard = new Clipboard(".copy-btn");
          this.clipboard.on("success", () => {
            this.$toast({ type: "success", message: "复制成功" });
          });
          // 添加图片预览功能
          const imgList = this.$refs.about.getElementsByTagName("img");
          for (var i = 0; i < imgList.length; i++) {
            this.imgList.push(imgList[i].src);
            imgList[i].addEventListener("click", function(e) {
              that.previewImg(e.target.currentSrc);
            });
          }
        });
    },
    markdownToHtml(data) {
      const MarkdownIt = require("markdown-it");
      const hljs = require("highlight.js");
      const md = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        highlight: function(str, lang) {
          // 当前时间加随机数生成唯一的id标识
          var d = new Date().getTime();
          if (
            window.performance &&
            typeof window.performance.now === "function"
          ) {
            d += performance.now();
          }
          const codeIndex = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function(c) {
              var r = (d + Math.random() * 16) % 16 | 0;
              d = Math.floor(d / 16);
              return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
            }
          );
          // 复制功能主要使用的是 clipboard.js
          let html = `<button class="copy-btn iconfont iconfuzhi" type="button" data-clipboard-action="copy" data-clipboard-target="#copy${codeIndex}"></button>`;
          const linesLength = str.split(/\n/).length - 1;
          // 生成行号
          let linesNum = '<span aria-hidden="true" class="line-numbers-rows">';
          for (let index = 0; index < linesLength; index++) {
            linesNum = linesNum + "<span></span>";
          }
          linesNum += "</span>";
          if (lang && hljs.getLanguage(lang)) {
            // highlight.js 高亮代码
            const preCode = hljs.highlight(lang, str, true).value;
            html = html + preCode;
            if (linesLength) {
              html += '<b class="name">' + lang + "</b>";
            }
            // 将代码包裹在 textarea 中，由于防止textarea渲染出现问题，这里将 "<" 用 "<" 代替，不影响复制功能
            return `<pre class="hljs"><code>${html}</code>${linesNum}</pre><textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy${codeIndex}">${str.replace(
              /<\/textarea>/g,
              "</textarea>"
            )}</textarea>`;
          }
        }
      });
      // 将markdown替换为html标签
      this.aboutContent = md.render(data);
    },
    previewImg(img) {
      this.$imagePreview({
        images: this.imgList,
        index: this.imgList.indexOf(img)
      });
    },
    checkIsAdmin() {
      this.isAdminDialog = true;
      this.showLock = false;
    },
    vaildIsAmind() {
      this.isAdminDialog = false;
      let param = {
        tb_name: "t_chat",
        password: this.admincheck.password
      }
      rightCheck(param).then(res=>{
          sessionStorage.setItem("chatPossword", this.admincheck.password);
          this.isAdminDialog = false;
          this.isvaildcheck = true;
      })
    }
  },
  computed: {
    avatar() {
      return this.$store.state.blogInfo.webSite.authorAvatar;
    },
    cover() {
      var cover = "";
      this.$store.state.blogInfo.pageList.forEach(item => {
        if (item.pageLabel === "about") {
          cover = item.pageCover;
        }
      });
      return "background: url(" + cover + ") center center / cover no-repeat";
    }
  }
};
</script>

<style scoped>
.about-content {
  word-break: break-word;
  line-height: 1.8;
  font-size: 14px;
}
.my-wrapper {
  text-align: center;
}
.author-avatar {
  transition: all 0.5s;
}
.author-avatar:hover {
  transform: rotate(360deg);
}
</style>

<style lang="scss">
pre.hljs {
  padding: 12px 2px 12px 40px !important;
  border-radius: 5px !important;
  position: relative;
  font-size: 14px !important;
  line-height: 22px !important;
  overflow: hidden !important;
  &:hover .copy-btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  code {
    display: block !important;
    margin: 0 10px !important;
    overflow-x: auto !important;
    &::-webkit-scrollbar {
      z-index: 11;
      width: 6px;
    }
    &::-webkit-scrollbar:horizontal {
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      width: 6px;
      background: #666;
    }
    &::-webkit-scrollbar-corner,
    &::-webkit-scrollbar-track {
      background: #1e1e1e;
    }
    &::-webkit-scrollbar-track-piece {
      background: #1e1e1e;
      width: 6px;
    }
  }
  .line-numbers-rows {
    position: absolute;
    pointer-events: none;
    top: 12px;
    bottom: 12px;
    left: 0;
    font-size: 100%;
    width: 40px;
    text-align: center;
    letter-spacing: -1px;
    border-right: 1px solid rgba(0, 0, 0, 0.66);
    user-select: none;
    counter-reset: linenumber;
    span {
      pointer-events: none;
      display: block;
      counter-increment: linenumber;
      &:before {
        content: counter(linenumber);
        color: #999;
        display: block;
        text-align: center;
      }
    }
  }
  b.name {
    position: absolute;
    top: 7px;
    right: 45px;
    z-index: 1;
    color: #999;
    pointer-events: none;
  }
  .copy-btn {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1;
    color: #ccc;
    background-color: #525252;
    border-radius: 6px;
    display: none;
    font-size: 14px;
    width: 32px;
    height: 24px;
    outline: none;
  }
}
</style>
